// TODO: can this be merged with ResourcesContent component?
import React from 'react'
import PropTypes from 'prop-types'
import { HeaderFour } from 'secondstep-components'
import ImageFullWidth from 'experienceComponents/ImageFullWidth'
import HeaderBodyCopy from 'experienceComponents/HeaderBodyCopy'
import ImageBodyCopyFlexible from 'components/ImageBodyCopyFlexible'
import InlineVideo from 'components/InlineVideo'
import LanguageToggle from 'experienceComponents/LanguageToggle'
import contentTypes from 'utils/contentfulParser/contents'
import { toCamelCase } from 'utils/stringHelpers'
import { PROGRAM_TYPES } from 'utils/programHelpers'
import { isTier2PreviewMode } from 'utils/urlHelpers'
import {
  ContentWrapper,
  Spacer,
  OuterContainer,
  StyledContainer,
  StyledTextLinkWithFileIcon,
  HeaderContainer,
  ButtonWrapper,
  LanguageToggleWrapper,
  StyledActivityButton,
} from './component.styles'
import {
  VIDEO_VARIANT,
  TEACH_BUTTON_TEXT,
  TEACH_BUTTON_TEXT_PREVIEW,
} from './constants'

const CONTENT_MAPPING = {
  headerBodyCopy: {
    component: HeaderBodyCopy,
    parser: (props, handlers) => {
      return {
        ...contentTypes.headerBodyCopy(props),
        ...handlers,
      }
    },
  },
  h4: {
    component: HeaderFour,
    parser: content => ({
      children: content?.h4Content,
      // this is a required prop:
      dataTestId: content?.h4Content?.toLowerCase()?.replace(' ', '-'),
    }),
  },
  textLinkIcon: {
    component: StyledTextLinkWithFileIcon,
    parser: contentTypes.textLinkIcon,
  },
  image: {
    // TODO: this may not be the best component to display image fullscreen
    // Revisit this for the zoom and pan ticket above:
    component: ImageFullWidth,
    parser: content => ({
      imageThumbnailUrl: content?.image?.file?.url || content?.image?.url,
      imageUrl: content?.image?.file?.url || content?.image?.url,
      title: '',
      isZoomable: true,
    }),
  },
  imageBodyCopyFlexible: {
    component: ImageBodyCopyFlexible,
    parser: entry => ({
      ...contentTypes.imageBodyCopyFlexible(entry),
      isZoomable: true,
      title: '',
    }),
  },
  video: {
    // this isn't ideal because it refetches the already fetched video
    component: InlineVideo,
    parser: content => {
      return {
        entryId: content?.id,
        locale: content?.locale,
        variant: VIDEO_VARIANT,
      }
    },
  },
  spacer: {
    component: Spacer,
    parser: content => ({
      height: content.pixelHeight,
    }),
  },
}

export const getContentComponent = (contentBlock, key, handlers) => {
  const mapping =
    CONTENT_MAPPING[contentBlock?.contentType?.id] ||
    CONTENT_MAPPING[toCamelCase(contentBlock?.__typename)]

  if (!mapping) {
    return null
  }
  const Component = mapping.component

  return <Component key={key} {...mapping.parser(contentBlock, handlers)} />
}

const HsIndividualResourceActivityDetails = ({
  audience,
  details,
  program,
  referenceHandler,
  presentation,
  launchActivity,
  getEntryWithNewLocale,
  locale,
  languageToggle,
}) => {
  const isHighSchool = program === PROGRAM_TYPES.HIGH_SCHOOL
  const isTier2Preview = isTier2PreviewMode()
  const hasButton = !!presentation && !isHighSchool
  const hasLanguageToggle = !!(languageToggle && getEntryWithNewLocale)

  const activityButton = hasButton ? (
    <StyledActivityButton onClick={() => launchActivity(isTier2Preview)}>
      {isTier2Preview ? TEACH_BUTTON_TEXT_PREVIEW : TEACH_BUTTON_TEXT}
    </StyledActivityButton>
  ) : null

  return (
    <>
      <OuterContainer audience={audience} isHighSchool={isHighSchool}>
        {!isHighSchool && <HeaderContainer>Lesson Plan</HeaderContainer>}
        <StyledContainer
          hasButton={hasButton}
          hasLanguageToggle={hasLanguageToggle}
          isHighSchool={isHighSchool}
        >
          {hasLanguageToggle && (
            <ButtonWrapper hasLanguageToggle={hasLanguageToggle}>
              <LanguageToggleWrapper locale={locale}>
                <LanguageToggle
                  boundary={!!languageToggle}
                  getEntryWithNewLocale={getEntryWithNewLocale}
                  locale={locale}
                />
              </LanguageToggleWrapper>
              {hasButton && activityButton}
            </ButtonWrapper>
          )}
          <ContentWrapper isHighSchool={isHighSchool}>
            {details?.content.map((content, index) =>
              getContentComponent(content, index, {
                referenceHandler,
                presentation,
                launchActivity,
                isPreview: isTier2Preview,
              }),
            )}
          </ContentWrapper>
          {hasButton && !hasLanguageToggle && activityButton}
        </StyledContainer>
      </OuterContainer>
    </>
  )
}

HsIndividualResourceActivityDetails.propTypes = {
  audience: PropTypes.string,
  details: PropTypes.object,
  getEntryWithNewLocale: PropTypes.func,
  languageToggle: PropTypes.object,
  launchActivity: PropTypes.func,
  locale: PropTypes.string,
  presentation: PropTypes.object,
  program: PropTypes.oneOf(Object.values(PROGRAM_TYPES)),
  referenceHandler: PropTypes.func,
}

export default HsIndividualResourceActivityDetails
